import styled from 'styled-components';
import parentsBg from '../../assets/images/parents_bg.png';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

const StyledParentsPreviewContainer = styled.div`
	position: relative;
	width: 440px;
	height: 242px;
	margin-left: -30px;
	background-image: url(${parentsBg});
	user-select: none;
	pointer-events: none;

	.parent1 {
		position: absolute;
		left: 53px;
		bottom: 0;
		width: 162px;
		height: 162px;
		z-index: 1;
	}

	.parent2 {
		position: absolute;
		right: 53px;
		bottom: 0;
		width: 182px;
		height: 182px;
		z-index: 2;
	}
`;

export { StyledContainer, StyledParentsPreviewContainer };
